import { render, staticRenderFns } from "./CompanyNonConformity.vue?vue&type=template&id=545505c9&scoped=true&"
import script from "./CompanyNonConformity.vue?vue&type=script&lang=js&"
export * from "./CompanyNonConformity.vue?vue&type=script&lang=js&"
import style1 from "./CompanyNonConformity.vue?vue&type=style&index=1&id=545505c9&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "545505c9",
  null
  
)

export default component.exports